import styled from 'styled-components';

const PaginationStyle = styled.div`
	--borderRadius: var(--sp1x);
	--iconSize: var(--sp5x);
	--gapDistance: var(--sp2x);
	--iconSizeArrow: var(--sp4x);

	display: flex;
	justify-content: flex-end;

	.pagination-inner-wrapper {
		display: flex;
		align-items: center;
		gap: var(--gapDistance);
	}

	.disable {
		pointer-events: none;
		opacity: 50%;
	}

	.dots {
		font-size: var(--p3);
		font-family: var(--montserrat_arm);
		font-weight: 500;
		line-height: var(--lineHeightL);
		color: var(--mainColor);
	}

	.pagination-item {
		/* width: var(--iconSize);
		height: var(--iconSize); */
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: var(--p3);
		font-family: var(--montserrat_arm);
		font-weight: 500;
		line-height: var(--lineHeightL);
		color: var(--mainColor);
		background-color: var(--backgroundColor);
		/* border-radius: var(--borderRadius); */
		transition: all var(--trTime) ease-out;
		cursor: pointer;

		&.active {
			pointer-events: none;
			color: var(--mainColor);
			background-color: var(--backgroundColor);
			border-bottom: 1px solid var(--mainColor);
		}
	}

	.next-btn,
	.prev-btn {
		/* width: var(--iconSize);
		height: var(--iconSize); */
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;

		&.disable {
			display: none;
		}
	}

	i {
		/* font-size: var(--h5); */
		font-size: var(--iconSizeArrow);
		color: var(--mainColor);
		transition: transform var(--trTime) ease-out;
	}

	@media (pointer: fine) {
		@media (hover: hover) {
			.pagination-item {
				&:hover {
					background-color: var(--blue100Color);
					color: var(--pink1000);
				}
			}

			i {
				&:hover {
					transform: scale(1.2);
				}
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--borderRadius: var(--sp1x);
		--iconSize: var(--sp3x);
		--gapDistance: var(--sp1-5x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--iconSizeArrow: var(--sp2-5x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--iconSizeArrow: var(--sp2-5x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--iconSize: var(--sp3-5x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
	}
`;

export default PaginationStyle;
